module.exports = __webpack_public_path__ + "static/media/fully-funded.f2df6d9e.png";